// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
import AccountDropdown from './AccountDropdown'
import Banners from './Banners'
import Cart from './Cart'
import ControlBar from './ControlBar'
import ControlBarItem from './ControlBar/ControlBarItem'
import GarageSection from './GarageSection'
import headerStyles from './Header.module.scss'
import HeaderDrawer from './HeaderDrawer'
import ListsNavItem from './Lists/ListsNavItem/ListsNavItem'
import { NavbarItem, NavbarItemLink } from './NavbarItem/NavbarItem'
import BackButton from './PWANavigation/BackButton'
import SaytDropdown from './SaytDropdown'
import SearchBarHeader from './SearchBarHeader'
import ToolboxBlade from './ToolboxBlade/ToolboxBlade'
import TopbarLink from './TopbarLink/TopbarLink'
import JsonLD from './json-ld/JsonLD'

import React, { useCallback, useContext, useEffect, useState } from 'react'

import { ThemeProvider, speedwayThemes } from 'Stores/ThemeStore'
import { useVehicleStore } from 'Stores/VehicleStore'
import ErrorBoundary from 'UtilityComponents/ErrorBoundary'
import ClassNames from 'classnames'

import { GetUserGuid } from 'Utilities/CookieUtilties/UserCookieUtilities'

import { NavigationContext } from 'Contexts/Navigation/NavigationContext'

import useCart from 'Hooks/useCart/useCart'
import useKeypress, { KEYCODES } from 'Hooks/useKepress'
import useNotificationCount from 'Hooks/useNotificationCount/useNotificationCount'

import CustomerProjectDrawer from 'Organisms/CustomerProjectDrawer/CustomerProjectDrawer'

import List from 'Molecules/List'

import Panel from 'Atoms/Panel'
import Svg from 'Atoms/Svg'
import TextLink from 'Atoms/TextLink/TextLink'

// we shim an implementation of "next/dynamic" in DS9 in webpack
// we HAVE to use magic comments https://loadable-components.com/docs/babel-plugin/#magic-comments
// const ToolboxBlade = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.ToolboxBlade)))
// const HeaderDrawer = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.HeaderDrawer)))
// const SaytDropdown = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.SaytDropdown)))
// const GarageSection = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.GarageSection)))
// const Banners = dynamic(() => Retry(() => import('./HeaderDefferedChunk/HeaderDefferedChunk').then(module => module.Banners)))

const yellowStyle = { fill: 'var(--color1, #ffc72c)' }
const purpleStyle = { fill: 'var(--color2, #470a68)' }
const logoStyleObject = { maxHeight: '140%' }

const Header = ({ currentTime, services, reserveBannerSpace, showPwaBackButton }) => {
  const [previousMenuItem, setPreviousMenuItem] = useState(null)

  const longPlaceholder = 'Search by vehicle, category, part number...'
  const brandPlaceholder = 'Search Speedway Motors'

  const { dispatch: navigationDispatch, state: navigationState } = useContext(NavigationContext)
  const [isSaytModalOpen, setIsSaytModalOpen] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const executeGarageReload = useVehicleStore((x) => x.executeGarageReload)
  const reloadCurrentLocation = useVehicleStore((x) => x.context.reloadCurrentLocation)
  const [isProductPage, setIsProductPage] = useState(false)
  const { drawer, garage } = navigationState
  const { isDrawerOpen } = drawer
  const { isCustomerProjectDrawerOpen } = garage
  // On PDPs and other pages that don't want redirect on garage change set reloadCurrentLocation true
  // Bug fix reported by Derek. Probably better place for this in future to look for @Blaine Traudt WIFR-32634
  useEffect(() => {
    try {
      if (window.SMI) {
        setIsProductPage(SMI.getPageTypeClass() === 'ProductPageTypePageContainer')
      }

      if (navigationState.pageType === 'PDP') {
        setIsProductPage(true)
      }
    } catch (err) {
      console.error('getPageTypeClass likely undefined:', err)
      setIsProductPage(false)
    }
    // keep tab in sync with global choice from TNG until we can call a function directly and remove this weird pass through
    // if (garage.market !== currentTab) {
    //     setCurrentTab(garage.market)
    // }
    // keep reload in sync with global choice from TNG until we can call a function directly and remove this weird pass through
    if (isProductPage || garage?.reloadCurrentLocation !== reloadCurrentLocation) {
      executeGarageReload(isProductPage || garage?.reloadCurrentLocation)
    }
  }, [garage, typeof window, isProductPage])

  useEffect(() => {
    //this is so that amp pages can cause the drawer to open and garage dropdown to open on page load
    if (window.location.hash) {
      var hash = window.location.hash.substring(1) //substring removes the # char
      if (hash == 'menu=1') {
        //open MOBILE drawer
        navigationDispatch({
          type: 'setDrawerState',
          payload: {
            drawerState: {
              isDrawerOpen: true,
            },
            drawerAction: { type: 'resetNavigation' },
          },
        })
      } else if (hash == 'vehicle=1') {
        //open MOBILE garage
        handleControlBarMenuClick('garage')
      }
    }
  }, [])

  const openSaytModal = async (e) => {
    setIsSaytModalOpen(true)
    setIsEditing(e.detail?.isEditing)
  }

  useEffect(() => {
    window.addEventListener('sayt_modal_opened', openSaytModal)

    return () => {
      window.removeEventListener('sayt_modal_opened', openSaytModal)
    }
  }, [])

  useKeypress(KEYCODES.escape, () => {
    setIsSaytModalOpen(false)
    navigationDispatch({
      type: 'setDrawerState',
      payload: {
        drawer: { isDrawerOpen: false },
      },
    })
  })

  const handleControlBarMenuClick = useCallback(
    (selectedMenu, market = 'street', reloadCurrentLocation = false) => {
      if (selectedMenu == previousMenuItem) {
        if (isDrawerOpen) {
          if (selectedMenu === 'garage') {
            if (isCustomerProjectDrawerOpen) {
              navigationDispatch({
                type: 'setCustomerProjectDrawerState',
                payload: {
                  garageState: {
                    isCustomerProjectDrawerOpen: false,
                  },
                },
              })
            }
          } else {
            navigationDispatch({
              type: 'setDrawerState',
              payload: {
                drawerState: { isDrawerOpen: false },
              },
            })
          }

          setPreviousMenuItem(selectedMenu)
          return
        }
      }

      switch (selectedMenu) {
        case 'menu':
          navigationDispatch({
            type: 'setDrawerState',
            payload: {
              drawerState: {
                isDrawerOpen: true,
              },
              drawerAction: { type: 'resetNavigation' },
            },
          })
          break
        case 'shop':
          navigationDispatch({
            type: 'setDrawerState',
            payload: {
              drawerState: {
                isDrawerOpen: true,
              },
              drawerAction: { type: 'gotoShopNavigation' },
            },
          })
          break
        case 'garage':
          navigationDispatch({
            type: 'setCustomerProjectDrawerState',
            payload: { garageState: { isCustomerProjectDrawerOpen: true } },
          })
          executeGarageReload(reloadCurrentLocation)
          break
        default:
          break
      }
      setPreviousMenuItem(selectedMenu)
    },
    [previousMenuItem, isDrawerOpen, isCustomerProjectDrawerOpen, executeGarageReload, navigationDispatch],
  )

  const getSelectedCustomerProjectTitle = useVehicleStore((x) => x.getSelectedCustomerProjectTitle)
  const vehicleTitle = getSelectedCustomerProjectTitle()

  const menuClickHandler = useCallback(() => handleControlBarMenuClick('menu'), [handleControlBarMenuClick])
  const shopClickHandler = useCallback(() => handleControlBarMenuClick('shop'), [handleControlBarMenuClick])
  const toolboxClickHandler = useCallback(() => (window.location.href = '/the-toolbox'), [])

  const headerDrawerCloseHandler = useCallback(() => {
    navigationDispatch({
      type: 'setDrawerState',
      payload: {
        drawerState: {
          isDrawerOpen: false,
        },
      },
    })
  }, [navigationDispatch])

  const customerProjectDrawerCloseHandler = useCallback(() => {
    navigationDispatch({
      type: 'setCustomerProjectDrawerState',
      payload: {
        garageState: {
          isCustomerProjectDrawerOpen: false,
        },
      },
    })
  }, [navigationDispatch])

  try {
    return (
      <>
        {/* <PdpSkeleton /> */}
        <header aria-label={'header'} role={'banner'}>
          <Panel className={ClassNames(headerStyles.headerTopBar)} brand={'primary'}>
            <TopbarLink
              className={ClassNames(headerStyles.phone)}
              tone={'contrast'}
              size={0.875}
              font={'heading'}
              href={'tel:18009790122'}
              testingName={'phoneNumber'}
            >
              Talk to the experts. Call 800.979.0122, 7am-10pm CST, everyday.
            </TopbarLink>
            <TopbarLink
              className={ClassNames(headerStyles.rewards)}
              icon={'rewards'}
              href={'/pages/rewards'}
              testingName={'rewards'}
            >
              REWARDS
            </TopbarLink>
            <TopbarLink
              className={ClassNames(headerStyles.giftCard)}
              icon={'creditcard'}
              href={'/giftcards'}
              testingName={'giftcards'}
            >
              GIFT CARDS
            </TopbarLink>
            <TopbarLink className={ClassNames(headerStyles.deals)} icon={'deals'} href={'/deals'} testingName={'deals'}>
              DEALS
            </TopbarLink>
            <TopbarLink
              className={ClassNames(headerStyles.trackOrder)}
              icon={'trackorder'}
              href={'/Track/OrderLocator'}
              testingName={'trackOrder'}
            >
              TRACK ORDER
            </TopbarLink>
            <TopbarLink
              className={ClassNames(headerStyles.help)}
              icon={'help'}
              href={'/info/helpcenter'}
              testingName={'helpCenter'}
            >
              HELP CENTER
            </TopbarLink>
          </Panel>
          <div className={ClassNames(headerStyles.headerContainer)}>
            <JsonLD />
            <Panel className={`${headerStyles.mobileHeaderBlock}`} brand={'primary'}>
              <BackButton show={showPwaBackButton} />
              <TextLink
                className={headerStyles.mobileIcon}
                title={'Home Page Link'}
                href={'/'}
                data-testid={'header-speedwaylogo-mobile'}
              >
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <symbol id="icon-SpeedwayMotors_Wheel_Full_Color" viewBox="0 0 45 45">
                      <path
                        fill="#ffc72c"
                        style={yellowStyle}
                        d="M25.144 0c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.175-16-16-16z"
                      ></path>
                      <path
                        fill="#470a68"
                        style={purpleStyle}
                        d="M23.516 19.072h-4.953c-0.212 0-0.331 0.169-0.387 0.303-0.262 0.628-0.506 1.272-0.738 1.919-0.438 1.241-0.028 2.072 1.047 2.072h9.234c1.031 0 1.906-0.65 2.425-1.759 0.616-1.309 1.113-2.694 1.587-4.072 0.375-1.103-0.103-1.897-1.047-1.9h-4.866c-0.594-0.003-0.778-0.384-0.525-1.072 0.436-1.228 0.684-1.864 0.939-2.495l-0.205 0.574c0.453-1.156 1.281-1.656 2.222-1.319 0.272 0.094 0.372 0.381 0.309 0.731-0.034 0.197-0.109 0.394-0.175 0.588-0.141 0.394-0.291 0.838-0.444 1.259l4.988-0.006c0.109 0 0.294-0.162 0.347-0.294 0.192-0.425 0.441-1.060 0.668-1.704l0.066-0.215c0.431-1.262 0.059-2.019-1.016-2.022-1.3-0.003-13.894 0.003-13.894 0.003l2.341 1.266c-0.105 0.142-0.553 1.253-0.988 2.37l-0.34 0.992c-0.184 0.488-0.378 0.988-0.481 1.494-0.175 0.847 0.209 1.441 0.894 1.509 0.163 0.016 0.331 0.019 0.497 0.019l4.475 0.006c0.75 0 0.931 0.359 0.613 1.219-0.206 0.559-0.419 1.116-0.637 1.675-0.462 1.188-1.019 1.584-2.038 1.462-0.541-0.066-0.7-0.416-0.469-1.063 0.172-0.491 0.359-1.025 0.55-1.541zM32.106 21.828c-0.125-0.075-0.281-0.113-0.459-0.113-0.181 0-0.334 0.041-0.462 0.116s-0.225 0.188-0.288 0.322c-0.025 0.056-0.047 0.116-0.059 0.178-0.011 0.057-0.017 0.122-0.017 0.188 0 0.146 0.029 0.285 0.082 0.412l-0.003-0.007c0.056 0.137 0.156 0.247 0.281 0.322s0.284 0.116 0.466 0.116c0.181 0 0.334-0.038 0.459-0.116 0.176-0.11 0.302-0.286 0.343-0.492l0.001-0.005c0.011-0.063 0.017-0.136 0.017-0.211s-0.006-0.148-0.018-0.219l0.001 0.008c-0.009-0.063-0.031-0.119-0.056-0.175-0.063-0.141-0.156-0.247-0.288-0.322zM32.309 22.719c-0.009 0.053-0.025 0.103-0.047 0.15-0.050 0.113-0.132 0.205-0.235 0.264l-0.003 0.001c-0.1 0.063-0.231 0.094-0.381 0.094-0.153 0-0.281-0.031-0.387-0.094s-0.181-0.147-0.234-0.266c-0.022-0.047-0.038-0.097-0.047-0.147-0.009-0.053-0.012-0.113-0.012-0.181 0-0.072 0.003-0.134 0.012-0.188 0.009-0.050 0.025-0.1 0.047-0.147 0.050-0.116 0.128-0.206 0.234-0.266 0.103-0.059 0.231-0.087 0.387-0.087 0.15 0 0.281 0.031 0.384 0.087 0.106 0.063 0.184 0.15 0.234 0.266 0.040 0.090 0.063 0.196 0.063 0.307 0 0.010-0 0.019-0.001 0.029l0-0.001c0 0.066 0 0.125-0.016 0.178z"
                      ></path>
                      <path
                        fill="#470a68"
                        style={purpleStyle}
                        d="M32.031 22.484c0.024-0.040 0.038-0.089 0.038-0.141 0-0.005-0-0.011-0-0.016l0 0.001c0-0.094-0.031-0.169-0.094-0.216-0.059-0.047-0.156-0.069-0.288-0.069h-0.434v1h0.178v-0.394h0.225c0.075 0 0.131 0.012 0.163 0.041s0.050 0.078 0.050 0.141v0.212h0.178v-0.231c0-0.063-0.013-0.113-0.034-0.153s-0.059-0.066-0.109-0.084c0.052-0.016 0.095-0.048 0.124-0.090l0.001-0.001zM31.828 22.462c-0.041 0.028-0.1 0.041-0.178 0.041h-0.216v-0.313h0.219c0.084 0 0.141 0.012 0.178 0.038s0.053 0.063 0.053 0.116c0 0.053-0.019 0.094-0.056 0.119z"
                      ></path>
                      <path
                        fill="#470a68"
                        style={purpleStyle}
                        d="M30.769 2.938l-0.038-0.013-0.25-0.103-0.063-0.031-0.231-0.087-0.087-0.031-0.219-0.081c-0.062-0.026-0.166-0.062-0.271-0.095l-0.041-0.011-0.119-0.038-0.2-0.063-0.125-0.038-0.197-0.056-0.137-0.034-0.191-0.050-0.334-0.078-0.15-0.031-0.184-0.041-0.156-0.031-0.181-0.031-0.169-0.028-0.175-0.028-0.172-0.025-0.172-0.022-0.181-0.019-0.166-0.019-0.191-0.016-0.159-0.016-0.203-0.009-0.15-0.012-0.231-0.006-0.125-0.006h-0.359c-0.006 0-0.013 0-0.020 0-4.762 0-8.975 2.349-11.545 5.951l-0.029 0.043c-0.358 0.501-0.712 1.076-1.026 1.674l-0.039 0.082c-0.983 1.877-1.56 4.1-1.56 6.457 0 0.394 0.016 0.785 0.048 1.171l-0.003-0.051h2.15c-0.006-0.175-0.012-0.35-0.012-0.528l0.006-0.294-0.006-0.281c0.011-6.651 5.402-12.038 12.053-12.044h0.026c0.391 0 0.775 0.022 1.156 0.059l0.063 0.006 0.156 0.019 0.188 0.022 0.031 0.003c2.83 0.395 5.295 1.723 7.126 3.657l0.005 0.006 0.462-1.169c2.459 2.394 3.984 5.736 3.984 9.435 0 0.003 0 0.006 0 0.010v-0c0 6.887-5.306 12.563-12.050 13.144h-0.009c-0.337 0.034-0.729 0.053-1.125 0.053h-0c-5.856-0.006-10.734-4.375-11.828-10.159h-2.084c1.458 6.431 7.12 11.162 13.89 11.172h0.001l0.356-0.003c0.106 0 0.206-0.006 0.313-0.012h0.038c7.541-0.398 13.506-6.606 13.512-14.209v-0.001c-0.005-5.82-3.5-10.822-8.506-13.027l-0.091-0.036z"
                      ></path>
                    </symbol>
                  </defs>
                  <use href="#icon-SpeedwayMotors_Wheel_Full_Color" />
                </svg>
              </TextLink>

              <SearchBarHeader
                isSaytModalOpen={isSaytModalOpen}
                placeholder={brandPlaceholder}
                className={headerStyles.mobileSearchBar}
                dataTesting={'searchBarMobile'}
                isMobile={true}
              />
            </Panel>
            <Panel className={ClassNames(headerStyles.headerDesktopView)} layer={0}>
              <List className={headerStyles.ds9Header} itemLayout={'horizontal'} component={'div'} display={'grid'}>
                <div className={ClassNames(headerStyles.navLeft, headerStyles.menuItem1)}>
                  <NavbarItem
                    component={'div'}
                    className={ClassNames(
                      headerStyles.headerItem,
                      headerStyles.mobileHide,
                      headerStyles.mobileLimitedHide,
                    )}
                    pwaOnly
                    hover
                  >
                    <BackButton show={showPwaBackButton} />
                  </NavbarItem>
                  <NavbarItem
                    className={ClassNames(
                      headerStyles.headerItem,
                      headerStyles.mobileHide,
                      headerStyles.mobileLimitedHide,
                      headerStyles.headerMenu,
                    )}
                    icon={'menu'}
                    onClick={menuClickHandler}
                    hover
                    data-testid={'menu'}
                    aria-label={'menu'}
                  />
                  <NavbarItemLink
                    className={ClassNames(
                      headerStyles.headerItem,
                      headerStyles.logoHeaderItem,
                      headerStyles.headerLogo,
                    )}
                    title={'Home Page Link'}
                    data-testid={'header-speedwaylogo'}
                    href={'/'}
                  >
                    <svg
                      className={ClassNames(
                        headerStyles.logoDesktop,
                        headerStyles.mobileHide,
                        headerStyles.tabletHide,
                        headerStyles.mobileLimitedHide,
                      )}
                      style={logoStyleObject}
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <symbol id="icon-SpeedwayMotors_Logo_Full_Color" viewBox="0 0 65 32">
                          <path
                            fill="#ffc72c"
                            style={yellowStyle}
                            d="M60.972 32c2.558-3.306 4.1-7.511 4.1-12.076 0-10.953-8.879-19.832-19.832-19.832s-19.832 8.879-19.832 19.832c0 4.565 1.542 8.77 4.134 12.122l-0.034-0.046h31.464z"
                          ></path>
                          <path
                            fill="#470a68"
                            style={purpleStyle}
                            d="M31.491 32h2.305c-2.106-2.095-3.548-4.855-3.985-7.939l-0.009-0.074h26.372c0.831-0.080 1.581-2.358 1.956-3.35l2.358-6.030h-2.385c-0.295 0-0.456 0.107-0.59 0.456l-1.796 4.556c-0.188 0.509-0.509 0.777-0.938 0.75-0.375-0.027-0.456-0.241-0.295-0.67l2.010-5.092h-3.859l0.884 0.563-2.144 5.36c-0.161 0.429-0.054 0.724 0.348 0.724h3.323c-0.322 0.992-0.241 1.796-0.992 1.822h-28.596l0.080 0.054 1.93 1.42c0.75 2.76 2.144 5.307 4.020 7.451z"
                          ></path>
                          <path
                            fill="#470a68"
                            style={purpleStyle}
                            d="M57.621 6.513c-1.481-1.387-3.21-2.533-5.11-3.359l-0.116-0.045-0.054-0.027-0.322-0.134-0.080-0.027-0.295-0.107-0.107-0.054-0.402-0.161-0.268-0.080-0.161-0.054-0.268-0.080-0.402-0.134-0.188-0.054-0.241-0.054-0.188-0.054-0.241-0.054-0.188-0.054-0.241-0.054-0.214-0.027-0.241-0.054-0.858-0.107-0.241-0.027-0.214-0.027-0.241-0.027-0.214-0.027-0.268-0.027h-1.099l-0.75 0.027-0.241 0.027-0.482 0.027-0.295 0.027-0.429 0.054c-0.117 0.005-0.227 0.024-0.331 0.056l0.010-0.002-0.402 0.054-0.322 0.054-0.402 0.080-0.322 0.080-0.375 0.080-0.322 0.080-0.375 0.107-0.322 0.107-0.348 0.107-0.322 0.107-0.348 0.134-0.322 0.134-0.348 0.134-0.322 0.134-0.322 0.161-0.295 0.134-0.322 0.161-0.295 0.161-0.322 0.161-0.295 0.161-1.179 0.75-0.295 0.214c-0.1 0.067-0.188 0.137-0.269 0.215l0.001-0.001-0.536 0.429c-0.080 0.077-0.168 0.148-0.261 0.21l-0.007 0.004-0.268 0.214-0.268 0.241-0.724 0.724-0.241 0.268-0.241 0.241-0.241 0.268-0.214 0.268c-0.077 0.080-0.148 0.168-0.21 0.261l-0.004 0.007-0.214 0.268-0.241 0.322-0.348 0.509-0.214 0.295-0.75 1.179-0.161 0.322-0.161 0.295-0.322 0.643-0.402 0.965-0.107 0.241h2.76c2.539-5.502 8.008-9.252 14.352-9.252 4.496 0 8.552 1.883 11.423 4.903l0.006 0.007 0.59-1.528c3.224 3.122 5.225 7.491 5.225 12.327 0 4.73-1.915 9.013-5.011 12.116v0h1.42c2.861-3.197 4.61-7.442 4.61-12.094 0-0.007 0-0.014 0-0.020v0.001c0.027-5.36-2.224-10.131-5.816-13.454z"
                          ></path>
                          <path
                            fill="#470a68"
                            style={purpleStyle}
                            d="M56.603 28.275h0.161l0.107 0.027 0.027 0.107v0.161h0.134v-0.161l-0.027-0.107-0.080-0.054c0.054 0 0.080-0.027 0.080-0.054l0.027-0.107-0.054-0.161-0.214-0.054h-0.322v0.724h0.134v-0.322zM56.603 27.953h0.161l0.134 0.027 0.027 0.080c0 0.054-0.027 0.080-0.054 0.080l-0.134 0.027h-0.161v-0.214z"
                          ></path>
                          <path
                            fill="#470a68"
                            style={purpleStyle}
                            d="M56.201 28.489c0.054 0.107 0.107 0.188 0.214 0.241 0.080 0.054 0.214 0.080 0.348 0.080s0.241-0.027 0.348-0.080 0.161-0.134 0.214-0.241l0.054-0.134v-0.322l-0.054-0.134c-0.054-0.107-0.107-0.188-0.214-0.241-0.080-0.054-0.214-0.080-0.348-0.080s-0.241 0.027-0.348 0.080c-0.080 0.054-0.161 0.134-0.214 0.241l-0.054 0.134v0.322l0.054 0.134zM56.281 28.060l0.027-0.107c0.027-0.080 0.080-0.161 0.161-0.188 0.080-0.054 0.161-0.054 0.295-0.054l0.268 0.054c0.080 0.054 0.134 0.107 0.161 0.188l0.027 0.107v0.268l-0.027 0.107c-0.027 0.080-0.107 0.161-0.161 0.188-0.080 0.054-0.161 0.054-0.268 0.054l-0.268-0.054c-0.080-0.054-0.134-0.107-0.161-0.188l-0.027-0.107v-0.134c-0.054-0.054-0.054-0.080-0.027-0.134zM14.714 18.734c0.188-0.241 0.375-0.536 0.509-0.911l0.59-1.447 0.188-0.59c0.054-0.241 0.054-0.456 0-0.616s-0.134-0.268-0.241-0.375c-0.107-0.080-0.214-0.161-0.348-0.188l-0.375-0.054h-4.851l-2.948 7.343h2.385l0.884-2.224h2.305l0.616-0.080c0.214-0.054 0.429-0.161 0.643-0.295 0.241-0.134 0.429-0.322 0.643-0.563zM13.534 16.054l-0.107 0.348-0.563 1.394c-0.107 0.268-0.214 0.429-0.322 0.509s-0.241 0.107-0.402 0.107h-1.126l1.072-2.653h1.179l0.241 0.054c0.054 0.080 0.054 0.134 0.027 0.241zM17.152 20.342l0.080-0.214 0.563-1.42h1.956l0.509-1.233h-1.956l0.456-1.099c0.080-0.188 0.161-0.322 0.268-0.429s0.241-0.161 0.375-0.161h1.903l0.482-1.233h-3.564c-0.456 0-0.831 0.134-1.152 0.456-0.316 0.326-0.577 0.707-0.767 1.127l-0.010 0.025-1.635 4.074-0.188 0.59c-0.027 0.348 0 0.616 0.107 0.804s0.348 0.295 0.697 0.295h3.538l0.482-1.206h-1.796c-0.268-0.027-0.375-0.134-0.348-0.375zM7.183 17.769h-2.6c-0.322 0-0.429-0.214-0.268-0.563l0.402-1.018c0.241-0.616 0.697-0.884 1.179-0.697 0.134 0.054 0.188 0.214 0.161 0.402l-0.107 0.322-0.241 0.67h2.68c0.054 0 0.161-0.080 0.188-0.161l0.402-1.018c0.241-0.67 0.027-1.072-0.536-1.072h-7.424l1.26 0.67c-0.199 0.43-0.534 1.29-0.851 2.159l-0.141 0.441c-0.080 0.456 0.107 0.777 0.482 0.804h2.653c0.402 0 0.509 0.188 0.322 0.643l-0.348 0.884c-0.241 0.643-0.536 0.858-1.099 0.777-0.295-0.027-0.375-0.214-0.241-0.563l0.295-0.831h-2.653c-0.107 0-0.188 0.080-0.214 0.161l-0.402 1.018c-0.241 0.67-0.027 1.099 0.563 1.099h4.931c0.563 0 1.018-0.348 1.286-0.938 0.322-0.697 0.59-1.447 0.858-2.171 0.214-0.59-0.027-1.018-0.536-1.018zM22.405 20.342l0.080-0.214 0.563-1.42h1.956l0.509-1.233h-1.956l0.456-1.099c0.080-0.188 0.161-0.322 0.268-0.429 0.096-0.098 0.228-0.159 0.375-0.161h1.903l0.482-1.233h-3.564c-0.456 0-0.831 0.134-1.152 0.456-0.316 0.326-0.577 0.707-0.767 1.127l-0.010 0.025-1.635 4.074-0.188 0.59c-0.027 0.348 0 0.616 0.107 0.804s0.348 0.295 0.697 0.295h3.538l0.482-1.206h-1.796c-0.268-0.027-0.375-0.134-0.348-0.375zM31.196 21.494c0.322-0.295 0.59-0.697 0.777-1.179l1.635-4.074 0.188-0.59c0.054-0.322 0.027-0.563-0.107-0.777-0.134-0.188-0.348-0.295-0.697-0.295h-5.387l-2.948 7.343h5.387c0.456-0.027 0.831-0.134 1.152-0.429zM29.347 20.583c-0.107 0.080-0.268 0.134-0.429 0.134h-1.313l1.956-4.905h1.42c0.107 0 0.161 0.027 0.214 0.107 0.027 0.080 0.054 0.161 0.027 0.268l-0.054 0.161-1.528 3.806c-0.107 0.188-0.188 0.348-0.295 0.429z"
                          ></path>
                          <path
                            fill="#470a68"
                            style={purpleStyle}
                            d="M32.161 21.896h8.951c0.643 0 1.126-0.429 1.447-1.206l2.332-6.111h-2.198c-0.295-0.027-0.456 0.134-0.59 0.482l-1.956 5.012c-0.348 0.884-0.536 1.018-1.34 0.858l2.492-6.352h-2.626l-2.198 5.575c-0.322 0.804-0.616 0.965-1.286 0.724l2.466-6.298h-3.618l0.804 0.429-2.090 5.36-0.59 1.528zM49.608 21.896c0.107 0 0.322-0.134 0.375-0.295l2.305-5.762c0.322-0.858 0.134-1.26-0.616-1.26h-4.502c-0.831 0-1.313 0.348-1.688 1.313l-2.358 6.030h2.519c0.107 0 0.295-0.188 0.375-0.322 0.241-0.509 0.429-1.045 0.616-1.554 0.107-0.268 0.214-0.402 0.482-0.375h0.884l-0.884 2.251h2.492zM47.142 18.734l1.045-2.626c0.214-0.482 0.536-0.616 0.938-0.563 0.295 0.027 0.402 0.241 0.268 0.59l-0.911 2.305c-0.054 0.134-0.241 0.268-0.348 0.295h-0.992zM38.325 26.345l-0.027 0.054-0.911 2.332h1.286l0.75-1.956 0.134-0.348 0.054-0.268v-0.322l-0.107-0.188c-0.048-0.049-0.114-0.079-0.187-0.080v0l-0.241-0.027h-5.601l0.804 0.429-1.072 2.76h1.286l0.911-2.332c0.054-0.161 0.161-0.241 0.268-0.241h0.456c0.080 0 0.134 0.054 0.107 0.134v0.054l-0.027 0.054-0.911 2.332h1.286l0.911-2.332c0.054-0.161 0.161-0.241 0.268-0.241h0.456c0.080 0 0.134 0.054 0.107 0.134v0.054zM39.745 28.73h2.198l0.429-0.054c0.107-0.027 0.214-0.107 0.322-0.188l0.241-0.295 0.214-0.429 0.509-1.26 0.134-0.456c0.027-0.188 0-0.295-0.080-0.402-0.080-0.080-0.241-0.134-0.482-0.134h-2.198l-0.429 0.054c-0.107 0.027-0.214 0.107-0.322 0.188l-0.241 0.295-0.214 0.429-0.509 1.26-0.134 0.456c-0.027 0.188 0 0.295 0.080 0.402 0.107 0.107 0.268 0.134 0.482 0.134zM40.71 27.873l0.563-1.42 0.107-0.188c0.054-0.054 0.107-0.054 0.188-0.054h0.59c0.107 0 0.161 0.054 0.161 0.134l-0.027 0.134-0.563 1.42-0.107 0.188c-0.054 0.054-0.107 0.054-0.188 0.054h-0.59c-0.107 0-0.161-0.054-0.134-0.134-0.054-0.054-0.027-0.107 0-0.134zM44.838 27.873l0.67-1.688h0.884l0.241-0.616h-0.884l0.268-0.697h-1.394l-1.126 2.894c-0.054 0.161-0.107 0.268-0.107 0.402-0.013 0.044-0.021 0.095-0.021 0.147s0.008 0.103 0.022 0.151l-0.001-0.004 0.107 0.188 0.188 0.107 0.241 0.027h1.528l0.241-0.616h-0.67l-0.188-0.027c-0.027-0.027-0.054-0.054-0.027-0.107l0.027-0.054c-0.027-0.054-0.027-0.080 0-0.107zM46.499 28.757h2.198l0.429-0.054c0.107-0.027 0.214-0.107 0.322-0.188l0.241-0.295 0.214-0.429 0.509-1.26 0.134-0.456c0.027-0.188 0-0.295-0.080-0.402-0.080-0.080-0.241-0.134-0.482-0.134h-2.198l-0.429 0.054c-0.107 0.027-0.214 0.107-0.322 0.188l-0.241 0.295-0.214 0.429-0.509 1.26-0.134 0.456c-0.027 0.188 0 0.295 0.080 0.402 0.080 0.080 0.241 0.134 0.482 0.134zM47.437 27.873l0.563-1.42 0.107-0.188c0.054-0.054 0.107-0.054 0.188-0.054h0.59c0.107 0 0.161 0.054 0.161 0.134l-0.027 0.134-0.563 1.42-0.107 0.188c-0.054 0.054-0.107 0.054-0.188 0.054h-0.59c-0.107 0-0.161-0.054-0.134-0.134v-0.134zM52.234 26.452c0.027-0.107 0.080-0.161 0.134-0.214l0.214-0.054h0.724l0.241-0.616h-1.528c-0.322 0-0.616 0.107-0.831 0.322s-0.402 0.482-0.563 0.858l-0.804 2.037h1.501l0.911-2.332zM55.129 26.265c0.054-0.054 0.134-0.080 0.241-0.080h0.616l0.241-0.616h-1.903l-0.348 0.054c-0.14 0.050-0.257 0.133-0.347 0.24l-0.001 0.001c-0.134 0.161-0.214 0.348-0.268 0.536v0.322l0.268 1.018v0.107l-0.107 0.188c-0.054 0.054-0.134 0.080-0.241 0.080h-0.643l-0.241 0.616h1.983c0.134 0 0.241-0.027 0.348-0.080s0.214-0.134 0.322-0.268l0.161-0.241 0.054-0.214v-0.188l-0.027-0.214-0.241-0.992v-0.134l0.134-0.134z"
                          ></path>
                        </symbol>
                      </defs>
                      <use href="#icon-SpeedwayMotors_Logo_Full_Color" />
                    </svg>
                    <Svg
                      icon={'SpeedwayMotors_Wheel_Full_Color'}
                      size={7}
                      className={ClassNames(
                        headerStyles.logoTablet,
                        headerStyles.mobileHide,
                        headerStyles.desktopHide,
                        headerStyles.mobileLimitedHide,
                      )}
                      brand={'primary'}
                    />
                    <Svg
                      icon={'SpeedwayMotors_Wheel_Full_Color'}
                      size={4}
                      className={ClassNames(headerStyles.tabletHide, headerStyles.desktopHide)}
                      brand={'primary'}
                    />
                  </NavbarItemLink>
                  <NavbarItem
                    className={ClassNames(
                      headerStyles.headerItem,
                      headerStyles.mobileHide,
                      headerStyles.tabletHide,
                      headerStyles.mobileLimitedHide,
                      headerStyles.headerShopParts,
                    )}
                    icon={'parts'}
                    primaryText={'Shop'}
                    secondaryText={'Parts'}
                    data-testid={'shopParts'}
                    onClick={shopClickHandler}
                    hover
                  />
                  <ErrorBoundary
                    key={`toolbox-blade`}
                    showFallbackUI
                    fallbackUI={
                      <NavbarItem
                        className={ClassNames(
                          headerStyles.headerItem,
                          headerStyles.mobileHide,
                          headerStyles.mobileLimitedHide,
                          headerStyles.headerToolbox,
                        )}
                        primaryText={'Learn'}
                        secondaryText={'Toolbox'}
                        icon={'toolbox'}
                        onClick={toolboxClickHandler}
                        hover
                        data-testid={'toolbox-fallback'}
                        aria-label={'toolbox'}
                      />
                    }
                  >
                    <ToolboxBlade
                      className={ClassNames(
                        headerStyles.headerItem,
                        headerStyles.mobileHide,
                        headerStyles.mobileLimitedHide,
                        headerStyles.headerToolbox,
                      )}
                      contentServiceUrl={services?.content?.url}
                    />
                  </ErrorBoundary>
                </div>
                <div className={ClassNames(headerStyles.navCenter, headerStyles.menuItem2)}>
                  <SearchBarHeader
                    isSaytModalOpen={isSaytModalOpen}
                    placeholder={longPlaceholder}
                    className={ClassNames(headerStyles.searchBar)}
                    dataTesting={'searchBarDesktop'}
                    isMobile={false}
                  />
                </div>
                <div className={ClassNames(headerStyles.navRight, headerStyles.menuItem3)}>
                  <GarageSection services={services} />
                  <AccountDropdown />
                  <ListsNavItem />
                  <Cart
                    classNames={ClassNames(
                      headerStyles.headerItem,
                      headerStyles.mobileHide,
                      headerStyles.mobileLimitedHide,
                      headerStyles.headerShoppingCart,
                    )}
                    url={services?.checkout?.url}
                  />
                </div>
              </List>
            </Panel>
            <Banners url={services?.content?.url} />
            <HeaderDrawer
              currentTime={currentTime}
              isDrawerOpen={isDrawerOpen}
              isDarkModeEnabled={true}
              closeFunction={headerDrawerCloseHandler}
              services={services}
            />
            <CustomerProjectDrawer
              isOpen={isCustomerProjectDrawerOpen}
              isProductPage={isProductPage}
              onClose={customerProjectDrawerCloseHandler}
            />
            <SaytDropdown
              isSaytModalOpen={isSaytModalOpen}
              setIsSaytModalOpen={setIsSaytModalOpen}
              className={(headerStyles.headerItem, headerStyles.menuItem5)}
              mobilePlaceholder={brandPlaceholder}
              desktopPlaceholder={longPlaceholder}
              ymmOrRaceTypeValue={vehicleTitle}
              services={services}
              isEditing={isEditing}
            />
            <MobileLowerNav
              isSaytModalOpen={isSaytModalOpen}
              key={false}
              onControlBarMenuClick={handleControlBarMenuClick}
              userGuid={GetUserGuid()}
              services={services}
              darkControlBarEnabled={true}
            />
          </div>
        </header>
      </>
    )
  } catch (e) {
    console.error(e)
    return false
  }
}
const MobileLowerNav = ({ onControlBarMenuClick, darkControlBarEnabled, isSaytModalOpen }) => {
  const { state: navigationState, dispatch: navigationDispatch } = useContext(NavigationContext)
  const executeGarageReload = useVehicleStore((x) => x.executeGarageReload)
  const customerProjects = useVehicleStore((x) => x.context.customerProjects)

  const { count } = useNotificationCount()
  // const executeGarageReload = useVehicleStore(x => x.executeGarageReload)

  const { cart } = useCart()
  const { discovery, controlBar, drawer, email } = navigationState
  const totalCustomerProjects = customerProjects ? customerProjects.length : 0
  const { isMenuActive, isShopActive, isGarageActive, isAccountActive, isCartActive } = controlBar

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.SMI) {
        window.SMI.showDs9YMMDropdownMobile = function (market = 'street', reloadCurrentLocation = false) {
          const totalCustomerProjects = customerProjects ? customerProjects.length : 0

          if (totalCustomerProjects > 0) {
            onControlBarMenuClick('garage', market, reloadCurrentLocation)
          } else {
            navigationDispatch({
              type: 'setGarageState',
              payload: {
                garageState: {
                  isCustomerProjectDrawerOpen: true,
                  market: market,
                },
              },
            })
            executeGarageReload(reloadCurrentLocation)

            return
          }
        }

        window.SMI.showGarageDropdown = function () {
          navigationDispatch({
            type: 'setCustomerProjectDrawerState',
            payload: { garageState: { isCustomerProjectDrawerOpen: true } },
          })
          return
        }
      }

      const isAnyControlBarItemActive = !isMenuActive && !isShopActive && !isGarageActive
      if (!isAccountActive && isAnyControlBarItemActive && window.location.href.toLowerCase().includes('/account')) {
        navigationDispatch({
          type: 'setControlBarState',
          payload: {
            controlBarState: {
              isAccountActive: true,
            },
          },
        })
      }
      if (!isCartActive && isAnyControlBarItemActive && window.location.href.toLowerCase().includes('/shoppingcart')) {
        navigationDispatch({
          type: 'setControlBarState',
          payload: {
            controlBarState: {
              isCartActive: true,
            },
          },
        })
      }
    }
  }, [typeof window, onControlBarMenuClick, customerProjects])

  const items = [
    {
      id: 'menu',
      icon: 'menu',
      onClick: () => onControlBarMenuClick('menu'),
      label: 'Menu',
      isActiveKey: 'isMenuActive',
    },
    {
      id: 'shop',
      icon: 'parts',
      onClick: () => onControlBarMenuClick('shop'),
      label: 'Shop',
      isActiveKey: 'isShopActive',
    },
    {
      id: 'garage',
      icon: 'garage',
      onClick: () => {
        onControlBarMenuClick('garage')
      },
      label: 'Garage',
      isActiveKey: 'isGarageActive',
    },
    {
      id: 'cart',
      icon: 'cart',
      href: '/shoppingcart',
      label: 'Cart',
      isActiveKey: 'isCartActive',
    },
    {
      id: 'account',
      icon: 'user',
      href: '/account',
      label: 'Account',
      isActiveKey: 'isAccountActive',
    },
  ]

  return (
    <ThemeProvider value={darkControlBarEnabled ? speedwayThemes.Dark : speedwayThemes.Light}>
      <ControlBar hide={isSaytModalOpen} darkControlBarEnabled={darkControlBarEnabled}>
        {items.map((item) => {
          const isActive = controlBar[item.isActiveKey]

          let props = null

          if (item.id === 'cart') {
            props = {
              badge: true,
              badgeProps: {
                brand: 'secondary',
                number: cart?.itemCount ?? 0,
                size: 'small',
              },
            }
          } else if (item.id === 'garage') {
            const garageBadgeBrand = darkControlBarEnabled ? 'secondarypalette_purple' : null
            const garageBadgeIntent = darkControlBarEnabled ? null : 'action'
            props = {
              badge: true,
              badgeProps: {
                brand: garageBadgeBrand,
                intent: garageBadgeIntent,
                number: totalCustomerProjects,
                size: 'small',
                removeNumber: true,
              },
            }
          } else if (item.id === 'account' && count) {
            props = {
              badge: true,
              badgeProps: {
                intent: 'negative',
                number: count,
                size: 'small',
                hideIfNumberIsFalsy: true,
                testid: 'noteCount-mobileNav',
              },
            }
          }

          return (
            <ControlBarItem
              id={item.id}
              key={item.label}
              href={item.href}
              onClick={item.onClick}
              label={item.label}
              icon={item.icon}
              isActive={isActive}
              invert={darkControlBarEnabled}
              {...props}
            />
          )
        })}
      </ControlBar>
    </ThemeProvider>
  )
}

export default Header
